export default __webpack_public_path__ + "static/media/facebook.fa4b1194.svg";